import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return ({
		pagesField: {
			width: "72px"
		},
		limitFieldLabel: {
			padding: "1rem 0 0 1rem"
		},
		pageSubtitle: {
			color: theme.palette.text.secondary,
			marginBottom: 32,
		},
		sectionHeading: {
			fontWeight: "bold",
			fontSize: 18,
			marginBottom: 4,
			color: theme.palette.custom.textPrimary,
		},
		subHeading: {
			fontWeight: 600,
			fontSize: 16,
			marginBottom: 24,
			marginTop: 8,
			color: theme.palette.custom.textPrimary,
		},
		helperText: {
			fontSize: 16,
			color: theme.palette.custom.textPrimary,
			marginTop: 4,
			marginBottom: 4,
		},
		infoIcon: {
			display: "inline-flex",
			alignItems: "center",
			marginLeft: 8,
			color: theme.palette.text.secondary,
			cursor: "default",
		},
		sectionDivider: {
			marginTop: 12,
			marginBottom: 12,
		},
		contentDescription: {
			fontSize: 16,
			marginBottom: 15,
			color: theme.palette.custom.textPrimary,
		},
		selectFrequency: {
			fontSize: 13,
			color: theme.palette.text.secondary,
			marginBottom: 2,
		},
		indented: {
			paddingLeft: 31,
			marginTop: 8,
			marginBottom: 4,
		},
		learnMore: {
			display: "inline-flex",
			alignItems: "center",
			gap: 4,
			fontSize: 13,
			marginBottom: 4,
		},
		textFieldLabel: {
			marginBottom: 4,
			fontSize: 14,
			color: theme.palette.custom.textPrimary,
		},
		pageLayout: {
			display: "flex",
			flexDirection: "column",
			height: "100%",
		},
		cardWrapper: {
			flexGrow: 1,
		},
	} satisfies Record<string, CSSObject>)
}
